export interface Actions {
  copy: boolean;
  file: boolean;
  message: boolean;
  drawer: boolean;
  select: boolean;
  options?: boolean;
}
